import Http from '../utils/http'

export const getCurrencies = () => Http.get('/settings/currencies')

export const getCountries = () => Http.get('/settings/countries')



// WEBPACK FOOTER //
// ./src/services/globals.js